import React from "react";
import EmpoweringGrowth from "../EmpoweringGrowth/EmpoweringGrowth";
import {Price} from "../index";
import StepSection from "../StepSection/StepSection";
import FeaturesHighlight from "../FeaturesHighlight/FeaturesHighlight";
import TrustedBrands from "../TrustedBrand/TrustedBrand";
import HeroSection from "../HeroSection/HeroSection";
import Testimonial from "../Testimonials/Testimonial";
import FAQSection from "../FAQs/FAQSection";
import LandingPage from "../Landing/LandingPage";
import { gapalyz } from "../../../../../images";
import Header from "../Header/Header";
import FeatureHighlightMotion from "../FeaturesHighlight/FeatureHighlightMotion";

const Home = () => {
  return (
    <>
      <div style={{ backgroundImage: `url(${gapalyz})`,wordWrap:"break-word",backgroundRepeat:"no-repeat",backgroundSize:"cover" }}>
        <Header />
        <HeroSection />
        <FeatureHighlightMotion />
        <StepSection />
        <EmpoweringGrowth />
        <TrustedBrands />
        <Price />
        <FAQSection />
         {/* <div className="" style={{padding: "6rem 9rem"}}> */}
             <Testimonial />
             {/* </div> */}
        <LandingPage />
      </div>

    </>
  );
};
export default Home;
